var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { inject } from "tsyringe";
import { IdMap, RArray } from "../../collections";
import { perRestaurant } from "../../di";
import { FulfillmentInstructions, FulfillmentInstructionsToken, } from "../FulfillmentInstructions";
import { ExtraFeeTypes } from "../Menu";
import { PackagingFeeInstance } from "./PackagingFeeInstance";
import { makeAutoObservable } from "mobx";
let PackagingFeeInstanceFactory = class PackagingFeeInstanceFactory {
    constructor(fulfillmentInstructions, extraFeeTypes) {
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.extraFeeTypes = extraFeeTypes;
        makeAutoObservable(this);
    }
    get applicableExtraFeeTypes() {
        const fulfillmentInstructions = this.fulfillmentInstructions.fulfillmentMethod;
        return this.extraFeeTypes.objects.filtered((packagingFeeType) => {
            switch (packagingFeeType.addedAt) {
                case "DeliveryAndTakeaway":
                    return (fulfillmentInstructions === "Delivery" ||
                        fulfillmentInstructions === "Takeaway");
                case "RestaurantAndTakeaway":
                    return (fulfillmentInstructions === "DineIn" ||
                        fulfillmentInstructions === "Takeaway");
                case "DeliveryOnly":
                    return fulfillmentInstructions === "Delivery";
                case "RestaurantOnly":
                    return fulfillmentInstructions === "DineIn";
                case "TakeawayOnly":
                    return fulfillmentInstructions === "Takeaway";
                case "Everywhere":
                    return true;
            }
        });
    }
    create({ orderLineIndex, orderLine: { productInstance, quantity: orderLineQuantity }, }) {
        return this.applicableExtraFeeTypes.flatMap((packagingFeeType) => {
            const { requirements } = packagingFeeType;
            const productInstanceResult = requirements.testProduct(productInstance)
                ? RArray.singleton(new PackagingFeeInstance({
                    packagingFeeType,
                    orderLineIndex,
                    subject: { type: "ProductType" },
                    quantity: orderLineQuantity,
                }))
                : RArray.empty();
            const modifierResults = productInstance.modifierInstances.flatMap((modifierInstance) => modifierInstance.selectedItems.mapOptional(({ modifierItemType: { id: modifierItemTypeId }, quantity: modifierItemQuantity, }) => requirements.testModifier(modifierInstance, modifierItemTypeId)
                ? new PackagingFeeInstance({
                    packagingFeeType,
                    orderLineIndex,
                    subject: { type: "ModifierItem", modifierItemTypeId },
                    quantity: orderLineQuantity.mul(modifierItemQuantity),
                })
                : null));
            return productInstanceResult.concatenated(modifierResults);
        });
    }
};
PackagingFeeInstanceFactory = __decorate([
    perRestaurant(),
    __param(0, inject(FulfillmentInstructionsToken)),
    __param(1, inject(ExtraFeeTypes)),
    __metadata("design:paramtypes", [typeof (_a = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _a : Object, typeof (_b = typeof IdMap !== "undefined" && IdMap) === "function" ? _b : Object])
], PackagingFeeInstanceFactory);
export { PackagingFeeInstanceFactory };
